import React from "react";
import { Select, InputNumber } from "antd";

import ConditionTypeSelect from "Components/condition-type-select";
import RuleSelect from "Components/rule-select";

import ParametersLayout from "Pages/private/parameters/layout";
import UserProfileLayout from "Pages/private/user-profile/layout";

import MailList from "Pages/private/parameters/mail-groups/mail-list";
import ConditionTypeInterestRates from "Pages/private/parameters/condition-type/interest-rates";
import IncreaseTypeList from "Pages/private/parameters/increase-type/list";
import LodgingPaymentsPage from "Pages/private/transactions/lodging-payments";
import HomePage from "Pages/private/home";
import ContractsPage from "Pages/private/transactions/contracts/list";
import NewContractPage from "Pages/private/transactions/contracts/new";
import CopyContractPage from "Pages/private/transactions/contracts/copy";
import ContractDetailsPage from "Pages/private/transactions/contracts/detail";
import EditContractPage from "Pages/private/transactions/contracts/edit";
import PartnersPage from "Pages/private/master-data/partners/list";
import NewPartnerPage from "Pages/private/master-data/partners/new";
import EditPartnerPage from "Pages/private/master-data/partners/edit";
import PartnerDetailsPage from "Pages/private/master-data/partners/details";
import UnitsPage from "Pages/private/master-data/units/list";
import NewUnitPage from "Pages/private/master-data/units/new";
import UnitDetailsPage from "Pages/private/master-data/units/details";
import EditUnitPage from "Pages/private/master-data/units/edit";
import SubUnitsPage from "Pages/private/master-data/sub-units/list";
import NewSubUnitPage from "Pages/private/master-data/sub-units/new";
import SubUnitDetailsPage from "Pages/private/master-data/sub-units/details";
import EditSubUnitPage from "Pages/private/master-data/sub-units/edit";
import RentableAreasPage from "Pages/private/master-data/rentable-area/list";
import NewRentableAreaPage from "Pages/private/master-data/rentable-area/new";
import RentableAreaDetailsPage from "Pages/private/master-data/rentable-area/details";
import EditRentableAreaPage from "Pages/private/master-data/rentable-area/edit";
import ContractReportsPage from "Pages/private/reports/contracts";
import HouseScoringReportPage from "Pages/private/reports/house-scoring";
import LodgementReportPage from "Pages/private/reports/lodgement";
import KinderGartenReportPage from "Pages/private/reports/kinder-garten";
import RealEstateReportPage from "Pages/private/reports/real-estate";
import RealEstateApa7ReportPage from "Pages/private/reports/real-estate-appendix-7";
import UserEventReportPage from "Pages/private/reports/user-events";
import UsersPage from "Pages/private/user-operations/user/list";
import NewUserPage from "Pages/private/user-operations/user/new";
import UserDetailsPage from "Pages/private/user-operations/user/details";
import EditUserPage from "Pages/private/user-operations/user/edit";
import AuthorizationsPage from "Pages/private/user-operations/authorizations/list";
import RealEstatesPage from "Pages/private/real-estates/list";
import NewRealEstatePage from "Pages/private/real-estates/new";
import RealEstateDetailsPage from "Pages/private/real-estates/details";
import RealEstateEditPage from "Pages/private/real-estates/edit";
import HousingScoringsPage from "Pages/private/master-data/housing-scoring/list";
import NewHousingScoringPage from "Pages/private/master-data/housing-scoring/new";
import HousingScoringDetailsPage from "Pages/private/master-data/housing-scoring/details";
import HousingScoringEditPage from "Pages/private/master-data/housing-scoring/edit";
import UserProfilePage from "Pages/private/user-profile";
import UserProfileEventsPage from "Pages/private/user-profile/user-events";
import UserGroupsPage from "Pages/private/user-operations/user-groups/list";
import UserGroupDetailPage from "Pages/private/user-operations/user-groups/detail";

const ruleColumn = (entity) => ({
  title: "Kural",
  dataIndex: ["rule", "id"],
  key: "rule",
  width: 300,
  editable: true,
  render: (text, record) => record.rule?.description,
  inputNode: <RuleSelect entity={entity} />,
});

const RouteList = [
  {
    path: "/panel",
    name: "Ana Sayfa",
    icon: {
      library: "fas",
      name: "home",
    },
    root: true,
    component: HomePage,
    navigation: true,
    authSubject: "Ana Sayfa",

    children: [
      {
        path: "/islemler",
        name: "İşlemler",
        icon: {
          library: "fas",
          name: "file-invoice",
        },
        navigation: true,
        component: null,
        extras: [],
        authSubject: "İşlemler",

        children: [
          {
            path: "/sozlesmeler",
            name: "Sözleşmeler",
            component: ContractsPage,
            icon: {
              library: "fas",
              name: "file-contract",
            },
            navigation: true,
            authSubject: "Sözleşmeler",

            children: [
              {
                path: "/yeni",
                name: "Yeni",
                component: null,
                authSubject: "Sözleşmeler",
                children: [
                  {
                    path: "/:contractTypeId",
                    name: "Yeni Sözleşme",
                    component: NewContractPage,
                    authSubject: "Sözleşmeler",
                  },
                ],
              },
              {
                path: "/:id",
                name: "Sözleşme",
                component: null,
                authSubject: "Sözleşmeler",
                children: [
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: EditContractPage,
                    authSubject: "Sözleşmeler",
                  },
                  {
                    path: "/kopyala",
                    name: "Kopyala",
                    component: CopyContractPage,
                    authSubject: "Sözleşmeler",
                  },
                  {
                    path: "/detay",
                    name: "Detay",
                    component: ContractDetailsPage,
                    authSubject: "Sözleşmeler",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <ContractDetailsPage archived={true} />;
                    },
                    authSubject: "Sözleşmeler",
                  },
                ],
              },
            ],
          },

          {
            path: "/lojman-kira-odeme",
            name: "Lojman Kira Ödeme Listesi",
            component: LodgingPaymentsPage,
            icon: {
              library: "fas",
              name: "hand-holding-usd",
            },
            navigation: true,
            authSubject: "Lojman Kira Ödeme Listesi",
          },
        ],
      },
      {
        path: "/ana-veriler",
        name: "Ana Veriler",
        icon: {
          library: "fas",
          name: "database",
        },
        component: null,
        navigation: true,
        extras: [],
        authSubject: "Ana Veriler",
        children: [
          {
            path: "/muhataplar",
            name: "Muhataplar",
            icon: {
              library: "fas",
              name: "id-card",
            },
            component: PartnersPage,
            navigation: true,
            extras: [],
            authSubject: "Muhataplar",
            children: [
              {
                path: "/yeni",
                name: "Yeni",
                component: NewPartnerPage,
                authSubject: "Muhataplar",
              },
              {
                path: "/:id",
                name: "Muhatap",
                component: null,
                authSubject: "Muhataplar",
                children: [
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: EditPartnerPage,
                    authSubject: "Muhataplar",
                  },
                  {
                    path: "/detay",
                    name: "Detay",
                    component: PartnerDetailsPage,
                    authSubject: "Muhataplar",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <PartnerDetailsPage archived={true} />;
                    },
                    authSubject: "Muhataplar",
                  },
                ],
              },
            ],
          },
          {
            path: "/birimler",
            name: "Birimler",
            icon: {
              library: "fas",
              name: "city",
            },
            component: UnitsPage,
            navigation: true,
            authSubject: "Birimler",
            children: [
              {
                path: "/yeni",
                name: "Yeni",
                component: NewUnitPage,
                authSubject: "Birimler",
              },
              {
                path: "/:id",
                name: "Birim",
                component: null,
                authSubject: "Birimler",
                children: [
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: EditUnitPage,
                    authSubject: "Birimler",
                  },
                  {
                    path: "/detay",
                    name: "Detay",
                    component: UnitDetailsPage,
                    authSubject: "Birimler",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <UnitDetailsPage archived={true} />;
                    },
                    authSubject: "Birimler",
                  },
                ],
              },
            ],
          },
          {
            path: "/alt-birimler",
            name: "Alt Birimler",
            icon: {
              library: "fas",
              name: "building",
            },
            component: SubUnitsPage,
            navigation: true,
            authSubject: "Alt Birimler",
            children: [
              {
                path: "/yeni",
                name: "Yeni",
                component: NewSubUnitPage,
                authSubject: "Alt Birimler",
              },
              {
                path: "/:id",
                name: "Alt Birim",
                component: null,
                authSubject: "Alt Birimler",
                children: [
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: EditSubUnitPage,
                    authSubject: "Alt Birimler",
                  },
                  {
                    path: "/detay",
                    name: "Detay",
                    component: SubUnitDetailsPage,
                    authSubject: "Alt Birimler",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <SubUnitDetailsPage archived={true} />;
                    },
                    authSubject: "Alt Birimler",
                  },
                ],
              },
            ],
          },
          {
            path: "/kiralanabilir-alanlar",
            name: "Kiralanabilir Alanlar",
            icon: {
              library: "fas",
              name: "store-alt",
            },
            component: RentableAreasPage,
            navigation: true,
            authSubject: "Kiralanabilir Alanlar",

            children: [
              {
                path: "/yeni",
                name: "Yeni",
                component: null,
                authSubject: "Kiralanabilir Alanlar",
                children: [
                  {
                    path: "/:rentableAreaTypeId",
                    name: "Yeni Kiralanabilir alan",
                    component: NewRentableAreaPage,
                    authSubject: "Kiralanabilir Alanlar",
                  },
                ],
              },
              {
                path: "/:id",
                name: "Kiralanabilir Alan",
                component: null,
                authSubject: "Kiralanabilir Alanlar",
                children: [
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: EditRentableAreaPage,
                    authSubject: "Kiralanabilir Alanlar",
                  },
                  {
                    path: "/detay",
                    name: "Detay",
                    component: RentableAreaDetailsPage,
                    authSubject: "Kiralanabilir Alanlar",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <RentableAreaDetailsPage archived={true} />;
                    },
                    authSubject: "Kiralanabilir Alanlar",
                  },
                ],
              },
            ],
          },
          {
            path: "/konut-puanlama",
            name: "Konut Puanlama Formları",
            icon: {
              library: "fas",
              name: "chart-line",
            },
            component: HousingScoringsPage,
            navigation: true,
            authSubject: "Konut Puanlama Formları",

            children: [
              {
                path: "/yeni",
                name: "Yeni Konut Puanlama Formu",
                component: NewHousingScoringPage,
                authSubject: "Konut Puanlama Formları",
              },
              {
                path: "/:id",
                name: "Konut Puanlama Formu",
                component: null,
                authSubject: "Konut Puanlama Formları",
                children: [
                  {
                    path: "/detay",
                    name: "Detay",
                    component: HousingScoringDetailsPage,
                    authSubject: "Konut Puanlama Formları",
                  },
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: HousingScoringEditPage,
                    authSubject: "Konut Puanlama Formları",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <HousingScoringDetailsPage archived={true} />;
                    },
                    authSubject: "Konut Puanlama Formları",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: "/kullanici",
        name: "Kullanıcı",
        icon: {
          library: "fas",
          name: "id-badge",
        },
        layout: true,
        component: UserProfileLayout,
        authSubject: "Kullanıcı",
        children: [
          {
            path: "/profil",
            name: "Bilgilerim",
            component: UserProfilePage,
            authSubject: "Kullanıcı",
          },
          {
            path: "/aktiviteler",
            name: "Aktivitelerim",
            component: UserProfileEventsPage,
            authSubject: "Kullanıcı",
          },
          /* {
            path: "/tercihler",
            name: "Tercihlerim",
            component: () => <div>Tercihlerim</div>,

          },*/
        ],
      },

      {
        path: "/tasinmazlar",
        name: "Taşınmazlar",
        icon: {
          library: "far",
          name: "file-alt",
        },
        component: RealEstatesPage,
        navigation: true,
        authSubject: "Taşınmazlar",

        children: [
          {
            path: "/yeni",
            name: "Yeni Taşınmaz",
            component: NewRealEstatePage,
            authSubject: "Taşınmazlar",
          },
          {
            path: "/:id",
            name: "Taşınmaz",
            component: null,
            authSubject: "Taşınmazlar",
            children: [
              {
                path: "/duzenle",
                name: "Düzenle",
                component: RealEstateEditPage,
                authSubject: "Taşınmazlar",
              },
              {
                path: "/detay",
                name: "Detay",
                component: RealEstateDetailsPage,
                authSubject: "Taşınmazlar",
              },
              {
                path: "/arsiv",
                name: "Arşiv",
                component: () => {
                  return <RealEstateDetailsPage archived={true} />;
                },
                authSubject: "Taşınmazlar",
              },
            ],
          },
        ],
      },

      {
        path: "/parametreler",
        name: "Parametreler",
        icon: {
          library: "fas",
          name: "sliders-h",
        },
        layout: true,
        component: ParametersLayout,
        navigation: true,
        authSubject: "Parametreler",
        children: [
          {
            name: "Ana Veriler",
            path: "/ana-veriler",
            navigation: true,
            authSubject: "Parametreler",
            children: [
              {
                path: "/muhatap-turleri",
                name: "Muhatap Türleri",
                api: "partnertypes",
                columnsExtended: [ruleColumn("PartnerType")],
                authSubject: "Muhatap Türleri",
              },
              {
                path: "/kisi-gorevi",
                name: "Kişi Görevi",
                api: "partnertasks",
                authSubject: "Kişi Görevi",
                columnsExtended: [
                  {
                    title: "Sıra",
                    dataIndex: "taskOrder",
                    key: "taskOrder",
                    editable: true,
                    inputNode: <InputNumber />,
                  },
                ],
              },
              {
                path: "/gorev-ayrim-unvani",
                name: "Görev Ayrım Unvanı",
                api: "taskdistinctiontitles",
                authSubject: "Görev Ayrım Ünvanı",
                columnsExtended: [
                  {
                    title: "Sıra",
                    dataIndex: "titleOrder",
                    key: "titleOrder",
                    editable: true,
                    inputNode: <InputNumber />,
                  },
                ],
              },
              {
                path: "/kiralanabilir-alan-tipleri",
                name: "Kiralanabilir Alan Tipleri",
                api: "rentableareatypes",
                columnsExtended: [ruleColumn("RentableAreaType")],
                authSubject: "Kiralanabilir Alan Tipleri",
              },
              {
                path: "/alt-birim-tipleri",
                name: "Alt Birim Tipleri",
                api: "subunittypes",
                authSubject: "Alt Birim Tipleri",
              },
            ],
          },
          {
            name: "Sözleşme",
            path: "/sozlesme",
            authSubject: "Parametreler",
            children: [
              {
                path: "/tipleri",
                name: "Tipleri",
                api: "contracttypes",

                columnsExtended: [ruleColumn("ContractType")],
                authSubject: "Sözleşme Tipleri",
              },
              {
                path: "/uzama-kurallari",
                name: "Uzama Kuralları",
                api: "contractextensionrules",
                authSubject: "Sözleşme Uzama Kuralları",
              },
              {
                path: "/kosul-tipleri",
                name: "Koşul Tipleri",
                api: "conditiontype",
                ItemsComponent: ConditionTypeInterestRates,
                authSubject: "Koşul Tipleri",

                columnsExtended: [
                  {
                    title: "Borç Göstergesi",
                    dataIndex: "debitCredit",
                    key: "debitCredit",
                    editable: true,
                    width: 220,
                    render: (text, record) =>
                      text === "DEBIT" ? "Borç" : "Alacak",
                    inputNode: (
                      <Select>
                        <Select.Option value="DEBIT" key="DEBIT">
                          Borç
                        </Select.Option>
                        <Select.Option value="CREDIT" key="CREDIT">
                          Alacak
                        </Select.Option>
                      </Select>
                    ),
                  },
                  {
                    title: "Faiz Grubu",
                    dataIndex: ["parentInterestConditionType"],
                    key: "parentInterestConditionType",
                    width: 220,
                    editable: true,
                    render: (text, record) =>
                      record.parentInterestConditionType?.description,
                    inputNode: <ConditionTypeSelect />,
                  },
                  ruleColumn("ConditionType"),
                ],
              },
              {
                path: "/kosul-amaclari",
                name: "Koşul Amaçları",
                api: "conditionpurposes",
                columnsExtended: [ruleColumn("ConditionPurpose")],
                authSubject: "Koşul Amaçları",
              },
              {
                path: "/bildirim-tipleri",
                name: "Bildirim Tipleri",
                api: "notificationtype",
                authSubject: "Bildirim Tipleri",
              },
              {
                path: "/artis-kurallari",
                name: "Artış Kuralları",
                api: "increasetypes",
                ItemsComponent: IncreaseTypeList,
                authSubject: "Artış Kuralları",
              },
              {
                path: "/vade-birimleri",
                name: "Vade Birimleri",
                api: "maturityunits",
                authSubject: "Vade Birimleri",
              },
              {
                path: "/sıklık-birimleri",
                name: "Sıklık Birimleri",
                api: "frequencyunits",
                authSubject: "Sıklık Birimleri",
              },
            ],
          },
          {
            name: "Taşınmaz",
            path: "/tasinmaz",
            authSubject: "Parametreler",
            children: [
              {
                path: "/tasinmaz-tipleri",
                name: "Taşınmaz Kayıt Türleri",
                api: "realestatetype",
                authSubject: "Gayrimenkul Tipleri",
              },
              {
                path: "/tasinmaz-durumlari",
                name: "Taşınmaz Durumları",
                api: "realestatestatu",
                authSubject: "Gayrimenkul Durumları",
              },
              {
                path: "/tasinmaz-cinsleri",
                name: "Taşınmaz Cinsleri",
                api: "dedtypes",
                editableCode: true,
                authSubject: "Tapu Türleri",
                columnsExtended: [ruleColumn("DeedType")],
              },
              {
                path: "/cikis-nedenleri",
                name: "Kayitlardan Çıkış Nedenleri",
                api: "outputshapes",
                authSubject: "Çıkış Şekilleri",
              },
              {
                path: "/edinme-sekilleri",
                name: "Edinme Şekilleri",
                api: "acquisitionfigures",
                authSubject: "Edinme Şekilleri",
              },
              {
                path: "/tasinmaz-nitelikleri",
                name: "Taşınmaz Nitelikleri",
                api: "realestatequalifications",
                authSubject: "Taşınmaz Nitelikleri",
              },
              {
                path: "/hukuki-durumlar",
                name: "Malik/Hukuki Durumlar",
                api: "legalstatus",
                authSubject: "Hukuki Durumlar",
              },
              {
                path: "/organizasyonlar",
                name: "Organizasyonlar",
                api: "organizations",
                authSubject: "Organizasyonlar",
              },
              {
                path: "/tahsis-amaclari",
                name: "Mevcut Kullanım Şekilleri / Tahsis Amaçları",
                api: "allocationpurposes",
                authSubject: "Tahsis Amaçları",
              },
            ],
          },
          {
            name: "Birimler ve Ölçümler",
            path: "/birimler-olcumler",
            authSubject: "Parametreler",
            children: [
              {
                path: "/donanim-tipleri",
                name: "Donanım Tipleri",
                api: "hardwaretype",

                authSubject: "Donanım Tipleri",
              },
              {
                path: "/donanim-markalari",
                name: "Donanım Markaları",
                api: "hardwaretypes",

                authSubject: "Donanım Markaları",
              },

              {
                path: "/olcum-tipleri",
                name: "Ölçüm Tipleri",
                api: "measurementtypes",
                columnsExtended: [ruleColumn("MeasurementType")],

                authSubject: "Ölçüm Tipleri",
              },
            ],
          },
          {
            name: "Diğer",
            authSubject: "Parametreler",
            path: "/diger",
            children: [
              {
                path: "/mail-gruplari",
                name: "Mail Grupları",
                api: "mailgroups",
                ItemsComponent: MailList,
                authSubject: "Mail Grupları",
              },
              {
                path: "/kullanici-birimleri",
                name: "Kullanıcı Birimleri",
                api: "userunits",
                authSubject: "Kullanıcı Birimleri",
              },
              {
                path: "/kurallar",
                name: "Kurallar",
                api: "rules",
                mode: "display",
                authSubject: "Kurallar",
              },
            ],
          },
        ],
      },
      {
        path: "/kullanici-islemleri",
        name: "Kullanıcı İşlemleri",
        icon: {
          library: "fas",
          name: "user",
        },
        component: null,
        navigation: true,
        authSubject: "Kullanıcı İşlemleri",

        children: [
          {
            path: "/kullanicilar",
            name: "Kullanıcılar",
            component: UsersPage,
            icon: {
              library: "fas",
              name: "users",
            },
            navigation: true,
            authSubject: "Kullanıcı Listesi",
            children: [
              {
                path: "/yeni",
                name: "Yeni",
                component: NewUserPage,
                authSubject: "Kullanıcı Listesi",
              },
              {
                path: "/:id",
                name: "Kullanıcı",
                component: null,
                authSubject: "Kullanıcı Listesi",
                children: [
                  {
                    path: "/duzenle",
                    name: "Düzenle",
                    component: EditUserPage,
                    authSubject: "Kullanıcı Listesi",
                  },
                  {
                    path: "/detay",
                    name: "Detay",
                    component: UserDetailsPage,
                    authSubject: "Kullanıcı Listesi",
                  },
                  {
                    path: "/arsiv",
                    name: "Arşiv",
                    component: () => {
                      return <UserDetailsPage archived={true} />;
                    },
                    authSubject: "Kullanıcı Listesi",
                  },
                ],
              },
            ],
          },
          {
            path: "/kullanici-gruplari",
            name: "Kullanıcı Grupları",
            component: UserGroupsPage,
            icon: {
              library: "fas",
              name: "user-tag",
            },
            navigation: true,
            authSubject: "Kullanıcı Grupları",

            children: [
              {
                path: "/:id",
                name: "Kullanıcı Grubu Detay",
                component: UserGroupDetailPage,
                authSubject: "Kullanıcı Grupları",
              },
            ],
          },
          /* {
            path: "/yetkiler",
            name: "Yetkiler",
            component: AuthorizationsPage,
            icon: {
              library: "fas",
              name: "certificate",
            },
            authSubject: "Yetkiler",

            navigation: true,
          },*/
          {
            path: "/kullanici-etkinlikleri",
            name: "Kullanıcı Etkinlikleri",
            component: UserEventReportPage,
            icon: {
              library: "fas",
              name: "id-badge",
            },
            authSubject: "Kullanıcı Etkinlikleri",

            navigation: true,
          },
        ],
      },
      {
        path: "/raporlar",
        name: "Raporlar",
        icon: {
          library: "fas",
          name: "table",
        },
        component: null,
        navigation: true,
        authSubject: "Raporlar",

        children: [
          {
            path: "/sozlesmeler",
            name: "Sözleşme Raporları",
            component: ContractReportsPage,
            icon: {
              library: "fas",
              name: "file-excel",
            },
            navigation: true,
            authSubject: "Sözleşme Raporları",
          },

          {
            path: "/kres-raporlari",
            name: "Kreş Raporları",
            component: KinderGartenReportPage,
            icon: {
              library: "fas",
              name: "file-excel",
            },
            authSubject: "Kreş Raporları",

            navigation: true,
          },

          {
            path: "/lojman-raporlari",
            name: "Lojman Raporları",
            component: LodgementReportPage,
            icon: {
              library: "fas",
              name: "file-excel",
            },
            authSubject: "Lojman Raporları",

            navigation: true,
          },

          {
            path: "/konut-puanlama-raporlari",
            name: "Konut Puanlama Raporları",
            component: HouseScoringReportPage,
            icon: {
              library: "fas",
              name: "file-excel",
            },
            authSubject: "Konut Puanlama Raporları",

            navigation: true,
          },

          {
            path: "/tasinmaz-raporlari",
            name: "Taşınmaz Raporları",
            component: RealEstateReportPage,
            icon: {
              library: "fas",
              name: "file-excel",
            },
            authSubject: "Taşınmaz Raporları",

            navigation: true,
          },
          {
            path: "/tasinmaz-raporlari-ek-7",
            name: "Taşınmaz Ek-7 Raporları",
            component: RealEstateApa7ReportPage,
            icon: {
              library: "fas",
              name: "file-excel",
            },
            authSubject: "Taşınmaz Raporları",

            navigation: true,
          },
        ],
      },
    ],
  },
];

export default RouteList;
